"use strict";

angular.module("vendor")
.controller("CustomerSendNotificationController", function(
    $scope, CustomerSendNotificationService, PartnershipStatusFilterService, PartnershipTagService
) {
    $scope.service = CustomerSendNotificationService;
    $scope.statusFilterService = PartnershipStatusFilterService;
    $scope.tagFilterService = PartnershipTagService;
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-send-notification.controller.js
// module id = 994
// module chunks = 0